module.exports = __webpack_public_path__ + "static/img/2.81f8af5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/2.png
// module id = I3oa
// module chunks = 0